import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

const Login = ({ login }) => {
    const [open, setOpen] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState("");
    const [alertSeverity, setAlertSeverity] = React.useState("success");

    const validationSchema = Yup.object({
        mobile: Yup.string().required(),
        password: Yup.string().required(),
    });

    const formik = useFormik({
        initialValues: {
            mobile: "",
            password: "",
        },
        validationSchema,
        onSubmit: (values) => {
            console.log("Form submitted with values:", values);
            const { mobile, password } = values;
            const mockApiResponse = (mobile, password) => {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        if (mobile === "1234" && password === "1234") {
                            resolve({ data: { success: true } });
                        } else {
                            resolve({ data: { success: false, message: "Invalid Details" } });
                        }
                    }, 1000);
                });
            };

            mockApiResponse(mobile, password)
                .then((response) => {
                    if (response.data.success) {
                        setAlertMessage("Login successful!");
                        setAlertSeverity("success");
                        setOpen(true);
                        setTimeout(() => {
                            login();
                        }, 500);
                    } else {
                        setAlertMessage("Wrong credentials!");
                        setAlertSeverity("error");
                        setOpen(true);
                    }
                })
                .catch(() => {
                    setAlertMessage("An error occurred, please try again.");
                    setAlertSeverity("error");
                    setOpen(true);
                });
        },
    });
    ;

    return (
        <>
            <div className="relative w-full h-screen bg-[#75aebf]">
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-8 py-6 bg-white rounded-lg shadow-lg min-w-[300px]">
                    <form className="flex flex-col" onSubmit={formik.handleSubmit}>
                        <h1 className="text-center text-2xl font-bold mb-6">Login Now</h1>

                        <label htmlFor="mobile" className="text-base font-medium text-black mb-1">Mobile No:</label>
                        <input
                            type="text"
                            id="mobile"
                            name="mobile"
                            className="w-full px-4 py-2 border border-gray-300 rounded-md"
                            value={formik.values.mobile}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.mobile && formik.errors.mobile ? (
                            <div className="text-red-500 text-sm mt-1">{formik.errors.mobile}</div>
                        ) : null}

                        <label htmlFor="password" className="text-base font-medium text-black mt-4 mb-1">Password:</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            className="w-full px-4 py-2 border border-gray-300 rounded-md"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.password && formik.errors.password ? (
                            <div className="text-red-500 text-sm mt-1">{formik.errors.password}</div>
                        ) : null}

                        <button
                            type="submit"
                            className="mt-6 submit_btn w-full py-2 bg-black text-white font-semibold rounded-md hover:bg-gray-800 transition duration-300"
                        >
                            Login
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default Login;
